import { useMemo } from 'react';

import { isMobile } from '@common/device-manager';

// MEMO: ZDS VerticalProductCardSlideItems에서 상품카드 width 계산 로직 참조. 마지막 더보기 버튼을 위한 width 계산.
export const useCarouselMoreButtonSlideWidth = () => {
  const slideWidth = useMemo(() => {
    const css_mode = isMobile();
    const space_between = 2;
    const slides_per_view = 3.14;
    const slides_offset_before = 16;
    const total_spacing = space_between * (slides_per_view - 1);
    const total_offset = total_spacing + (css_mode ? -slides_offset_before : slides_offset_before);
    const spacing_per_slide = total_offset / slides_per_view;
    return `calc(${100 / slides_per_view}% - ${spacing_per_slide}px)`;
  }, []);

  return slideWidth;
};
